import * as store from '@attain-apps/fe/web/main/lib/store'
import type cytoscape from 'cytoscape'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getEdgeDataDefinition } from '../elements'
import type { Manager } from '../manager'

export const assignNodeInCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.assign.observe().pipe(
      rxjs.map(({ data: { edge, orgChartId } }) => {
        const cy = manager.getInstance({ orgChartId })
        if (!cy) {
          return
        }
        // Removes old edges
        cy.edges()
          .filter(_edge => {
            if (_edge.target().id() === edge.childId) {
              // Removes existing edges to this child since it is being
              // reassigned to a new parent
              return true
            }
            if (_edge.source().id() === edge.childId) {
              // Removes any edges from this child that would cause a
              // cycle with the new edge
              const visited = new Set()
              const descendants = [_edge.target()]
              let descendant: cytoscape.NodeSingular | undefined
              while ((descendant = descendants.pop())) {
                if (descendant.id() === edge.parentId) {
                  return true
                }
                visited.add(descendant)
                descendants.push(
                  ...descendant
                    .outgoers()
                    .nodes()
                    .filter(node => !visited.has(node.id())),
                )
              }
            }
            // Doesn't remove anything else
            return false
          })
          .remove()
        // Adds new parent
        cy.add({ data: getEdgeDataDefinition(edge) })

        // Apply layout to accommodate new node
        manager.resetLayout({ orgChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
